import Component from '../core/Component';
import $ from 'jquery';

export default class LoadMore extends Component
{
    constructor($element)
    {
        super($element);
    }

    prepare()
    {
        this.$element.click(function (event) {
            event.preventDefault();
            var href = $(this).data('href');
            $.nette.ajax({
                url: href
            });
        });
    }
}


// WEBPACK FOOTER //
// ./components/LoadMore.js